import { render, staticRenderFns } from "./MessageBoard.vue?vue&type=template&id=73822664&scoped=true"
import script from "./MessageBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBoard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageBoard.vue?vue&type=style&index=0&id=73822664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73822664",
  null
  
)

export default component.exports